import React, { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import countryData from '../config/dropdowns/country.json';
import industryData from '../config/dropdowns/industry.json';
import brandMetricTypeData from '../config/dropdowns/brandMetricType.json';
import { BrcContext } from '../BrcContextWrapper';
import { EMPTY_CAMPAIGN_FILTERS } from '../constants/campaign';
import { Button } from 'react-bootstrap';

const ConfigAccordion = ({ columns, filterData, setFilterData }) => {
  const { setCampaignColumns } = useContext(BrcContext);

  return (
    <Accordion defaultActiveKey={[]} style={{ width: '100%' }}>
      <Accordion.Item eventKey="0">
        <Accordion.Header style={{ backgroundColor: '#fafafa' }}>
          Filtering Options
        </Accordion.Header>
        <Accordion.Body>
          <div
            style={{
              width: '100%',
              minHeight: '250px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              padding: '10px',
              gap: '25px',
            }}
          >
            <div
              style={{
                flex: 0.5,
                height: '100%',
                borderRadius: '10px',
                backgroundColor: '#fafafa',
                position: 'relative',
                paddingTop: '30px',
              }}
            >
              <h3
                style={{
                  position: 'absolute',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#fafafa',
                  border: '1px solid #f4f4f4',
                  top: '-10px',
                  left: '-10px',
                  fontSize: '16px',
                }}
              >
                Column Filtering
              </h3>
              <Form
                style={{
                  width: '100%',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {columns
                  .filter((c) => c.showInColumnFilters)
                  .map((column, index) => {
                    return (
                      <Form.Check
                        style={{ width: '150px', textAlign: 'left', paddingBottom: '5px' }}
                        type="switch"
                        label={`${column.label}`}
                        id={`${column.id}`}
                        key={index}
                        checked={!column.omit}
                        onChange={(e) => {
                          setCampaignColumns((prevState) => {
                            if (e.target.checked) {
                              return [...prevState, e.target.id];
                            } else {
                              return prevState.filter((item) => item !== e.target.id);
                            }
                          });
                        }}
                      />
                    );
                  })}
              </Form>
            </div>
            <div
              style={{
                flex: 1,
                height: '100%',
                minHeight: '250px',
                borderRadius: '10px',
                backgroundColor: '#fafafa',
                position: 'relative',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                padding: '40px',
              }}
            >
              <h3
                style={{
                  position: 'absolute',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#fafafa',
                  border: '1px solid #f4f4f4',
                  top: '-10px',
                  left: '-10px',
                  fontSize: '16px',
                }}
              >
                Table Filtering
              </h3>
              {/* <div style={{ width: '200px', height: '60px', border: '1px solid black' }}></div> */}
              <Form
                style={{
                  width: '100%',
                  display: 'flex',
                  gap: '20px 40px',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {columns
                  .filter((c) => c.showInFilters === true)
                  .map((column, index) => {
                    const onChangeFunc = (e) =>
                      setFilterData((prevState) => ({ ...prevState, [column.id]: e.target.value }));
                    const value = filterData[column.id];

                    return (
                      <Form.Group key={index}>
                        <Form.Label style={{ textAlign: 'left', width: '100%' }}>
                          {column.label}
                        </Form.Label>
                        {column.type === 'select' ? (
                          <Form.Select
                            required
                            aria-label={`${column.label} select`}
                            value={value}
                            style={{ width: '300px' }}
                            onChange={onChangeFunc}
                          >
                            <option value="">Please Choose {column.label}</option>
                            {column.options?.map((item, index) => {
                              const optionValue = item?.value ?? item;
                              const optionLabel = item?.label ?? item;
                              return (
                                <option value={optionValue} key={index}>
                                  {optionLabel}
                                </option>
                              );
                            })}
                          </Form.Select>
                        ) : (
                          <Form.Control
                            style={{ width: '300px', textAlign: 'left', paddingBottom: '5px' }}
                            type={column.type}
                            onChange={onChangeFunc}
                            value={value}
                            placeholder={`Please Enter ${column.label}`}
                            {...(column.filterOptions ?? {})}
                          />
                        )}
                      </Form.Group>
                    );
                  })}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    onClick={() => {
                      setFilterData({ ...EMPTY_CAMPAIGN_FILTERS });
                    }}
                  >
                    Reset Filters
                  </Button>
                </div>{' '}
              </Form>
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ConfigAccordion;
